import { render } from "./AddLicense.vue?vue&type=template&id=6040d19e&ts=true"
import script from "./AddLicense.vue?vue&type=script&lang=ts"
export * from "./AddLicense.vue?vue&type=script&lang=ts"

import "./Licenses.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__